var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { base64, logger } from ".";
import { useEffect, useState } from "react";
var _client;
var _systemKey;
function configure() {
    const teamUsername = process.env.REACT_APP_FLAG_USERNAME;
    const teamPassword = process.env.REACT_APP_FLAG_PASSWORD;
    const systemKey = process.env.REACT_APP_FLAG_SYSTEM_KEY;
    const server = process.env.REACT_APP_FLAG_SERVER;
    if (systemKey === undefined ||
        systemKey === null ||
        teamUsername === undefined ||
        teamUsername === null ||
        teamPassword === undefined ||
        teamPassword === null)
        throw new Error("Feature flags keys can't be null or empty!");
    const encodedBasic = base64.encode(`${teamUsername}:${teamPassword}`);
    _client = axios.create({
        headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${encodedBasic}`,
        },
        baseURL: server,
    });
    _systemKey = systemKey;
}
function isConfigured() {
    let isConfigured = _client !== undefined && _systemKey !== undefined;
    if (isConfigured)
        logger.debug(`Feature flag is configured and ready to act!`);
    else
        logger.warn(`Feature flag isn't enabled yet`);
    return isConfigured;
}
function isEnabledAsync(flagKey) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield _client
            .get(`/Systems/${_systemKey}/Flags/${flagKey}`)
            .then((resp) => resp.data.enabled)
            .catch((err) => {
            logger.error(`Error on check flag '${flagKey}':/ \n ${err}`);
            return false;
        });
    });
}
function getSummaryAsync(flagKey) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield _client
            .get(`/Systems/${_systemKey}/Flags/${flagKey}/Summary`)
            .then((resp) => resp.data)
            .catch((err) => {
            logger.error(`Error on check flag '${flagKey}' summary: \n ${err}`);
            return {
                enabled: 0,
                disabled: 1,
            };
        });
    });
}
export function FeatureFlag(props) {
    const [isEnabled, setIsEnabled] = useState(false);
    useEffect(() => {
        const timer = setInterval(() => {
            if (isConfigured()) {
                logger.debug(`Checking flag '${props.feature}'`);
                isEnabledAsync(props.feature)
                    .then((resp) => {
                    setIsEnabled(resp);
                    logger.debug(`Flag '${props.feature}' is ${resp ? "enabled" : "disabled"}`);
                })
                    .catch((err) => logger.error(`Error on check flag '${props.feature}': ${err}`));
            }
        }, 10 * 1000); // every 10 seconds
        return () => {
            clearTimeout(timer);
        };
    }, []);
    return (isEnabled
        ? props.onEnabled
        : props.onDisabled);
}
export const flags = {
    configure,
    isEnabledAsync,
    getSummaryAsync,
};
